import { useEffect } from "react";

/** Sets `document.title` while the calling component is mounted and restores
 *  the previous title on unmount, so a page never leaves its title behind. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;

    return () => {
      document.title = previous;
    };
  }, [title]);
}
